import { Controller } from "@hotwired/stimulus"

// Aktualisiert #jobs_count in der Titelzeile, wenn die Job-Liste per Turbo-Frame
// neu geladen wird (Filter, Sortierung, Pagination). Der Count liegt ausserhalb
// des jobs-Frames und wird serverseitig nicht mitgerendert.
export default class extends Controller {
  static values = { count: Number }

  connect() {
    const el = document.getElementById("jobs_count")
    if (el) el.textContent = `(${this.countValue})`
  }
}
